import { scroll } from "motion";
import debounce from "lodash/debounce";
import "./questions.css";

let trackers = [];

const setupHeights = (el) => {
  const contentColumn = el.querySelector(".content-column");
  const listColumn = el.querySelector(".list-column");
  const lastElement = listColumn.querySelector("li:last-child");

  const isTwoColumn = window.matchMedia("(min-width: 768px)").matches;
  const contentHeight = contentColumn.offsetHeight;
  const listHeight = listColumn.offsetHeight;

  if (isTwoColumn && listHeight > contentHeight) {
    const offset = contentColumn.offsetHeight - lastElement.offsetHeight;
    listColumn.style.paddingBottom = `${offset}px`;
  } else {
    listColumn.style.paddingBottom = null;
  }
};

const setupScrollTracking = (el) => {
  const listItems = el.querySelectorAll(".list-column li");
  let currentActive = null;
  const firstItem = listItems[0];
  const lastItem = listItems[listItems.length - 1];
  let lastScrollY = window.scrollY;
  let lastActiveItem = firstItem;
  let latestRequest = null;
  const images = el.querySelectorAll(".callout-image");

  firstItem.classList.add("is-active");
  currentActive = firstItem;

  const setActiveItem = (item) => {
    latestRequest = item;

    requestAnimationFrame(() => {
      if (latestRequest === item) {
        if (currentActive !== item) {
          currentActive?.classList.remove("is-active");
          item.classList.add("is-active");

          if (lastActiveItem !== item) {
            if (images.length) {
              images.forEach((image) => image.classList.remove("opacity-100"));

              el.querySelector(`.callout-image[data-pos="${item.dataset.pos}"]`).classList.add("opacity-100");
            }
            lastActiveItem = item;
          }

          currentActive = item;
        }
      }
    });
  };

  listItems.forEach((item) => {
    const tracker = scroll(
      ({ y }) => {
        const scrollingDown = window.scrollY > lastScrollY;
        lastScrollY = window.scrollY;

        if (y.progress > 0.1 && y.progress < 0.9) {
          setActiveItem(item);
        } else if (item === firstItem && y.progress <= 0.1) {
          setActiveItem(item);
        } else if (item === lastItem && y.progress >= 0.9 && scrollingDown) {
          setActiveItem(item);
        }
      },
      {
        target: item,
        offset: ["start 40%", "end -40%"],
      },
    );
    trackers.push(tracker);
  });
};

document.querySelectorAll(".element-questions").forEach((el) => {
  setupHeights(el);
  setupScrollTracking(el);
});

window.addEventListener(
  "resize",
  debounce(() => {
    trackers.forEach((tracker) => tracker());
    trackers = [];
    document.querySelectorAll(".element-questions").forEach((el) => {
      setupHeights(el);
      setupScrollTracking(el);
    });
  }, 250),
);
